import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { OUTPUT_OPTIONS, S3_URL, TEST_RESULT_OPTIONS, HAS_EXPIRED_INVESTIGATION_CASE_STATUS } from "../services/Constants";
import _ from "lodash";
import RulesScreenOrCondition from "./RulesScreenOrCondition";
import {
  HL7_FIELDS_FOR_NUMERIC_VALUES,
  HL7_FIELDS_FOR_DATE_VALUES,
  HL7_FIELDS_FOR_DROPDOWN_VALUES,
} from "../services/Constants";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { validateAndSanitizeUrl } from "../util/common";

const initialRules = [
  {
    ruleName: "",
    ruleCategory: "Business",
    sendingFacilityId: "", //later work on getting facility id
    isActive: true,
    ruleDescription: "",
    isDel: false,
    startDate: null,
    endDate: null,
    ruleConditions: [
      {
        sourceObject: "SurveillanceSystem",
        sourceField: "Result",
        valueRhs: "Select",
        seqNum: 1,
        logicalOperator: "&&",
        isDel: false,
        operator: "Equal to",
      },
      {
        sourceObject: "SurveillanceSystem",
        sourceField: "condition",
        valueRhs: "",
        seqNum: 2,
        logicalOperator: "&&",
        isDel: false,
        operator: "Equal to",
      },
    ],
    ruleActions: [
      {
        sourceObject: "output",
        sourceField: "Output",
        operator: "",
        valueRhs: "",
        seqNum: 999,
        isDel: false,
      },
    ],
  },
];

const RulesScreenDecisionTable = forwardRef((props, ref) => {
  const { orCondition, setOrCondition, orNameCondition, setOrNameCondition } =
    props;
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [showConditionModal, setShowConditionModal] = useState(false);
  const [ruleConditionVisualizationModal, setRuleConditionVisualizationModal] =
    useState(false);
  const [ruleConditionForRow, setRuleConditionForRow] = useState("");
  const [administrativeSexCodeSets, setAdministrativeSexCodeSets] = useState(
    []
  );
  const [raceCodeSets, setRaceCodeSets] = useState([]);
  const [ethnicGroupCodeSet, setEthnicGroupCodeSet] = useState([]);
  const [patientDeathIndicatorCodeSets, setPatientDeathIndicatorCodeSets] =
    useState([]);
  const [specimenSourceSite, setSpecimenSourceSite] = useState([]);
  const [specimenType, setSpecimenType] = useState([]);
  const [caseTestResult, setCaseTestResult] = useState([]);
  const [existingCaseCodeSets, setExistingCaseCodeSets] = useState([]);
  const [existingCaseNumber, setExistingCaseNumbers] = useState([]);
  const [syphilisTestCombinationTable, setSyphilisTestCombinationTable] =
    useState([]);
  const [multipleTierOnePositiveTests, setMultipleTierOnePositiveTests] =
    useState([]);
  const [existingSingleSyphilisTestFlag, setExistingSingleSyphilisTestFlag] =
    useState([]);
  const [hasClosedInvestigationStatus, setHasClosedInvestigationStatus] =
    useState([]);
  const [caseStatus, setCaseStatus] = useState([]);
  const [caseType, setCaseType] = useState([]);
  const [lockStatus, setLockStatus] = useState([]);
  const [
    hasExpiredInvestigationCaseStatus,
    setHasExpiredInvestigationCaseStatus,
  ] = useState([]);

  const [outputOptions, setOutputOptions] = useState([]);

  const [rules, setRules] = useState(
    props.rulesList.length > 0
      ? props.rulesList
      : JSON.parse(JSON.stringify(initialRules))
  );
  let copyColumns = [];

  const handleConditionModalClose = () => setShowConditionModal(false);

  const handleRuleConditionVisualizationModalClose = () =>
    setRuleConditionVisualizationModal(false);

  const getColumnsMetaData = () => {
    let result = {};
    props.objectsData.forEach((element) => {
      let refValues = element.refTableValues;
      refValues.forEach((item) => {
        result = Object.assign(
          { [item.reference_code]: item.reference_Code_description },
          result
        );
      });
    });
    result = Object.assign(
      result,
      { object: "Object" },
      { Result: "Test Result" },
      { condition: "Condition" }
    );

    return result;
  };

  const addDecisionsFields = (testResult) => {
    let firstRule = { ...rules[0] };
    delete firstRule.ruleId;

    let newConditions = firstRule.ruleConditions.map((obj) => {
      return {
        ...obj,
        conditionId: null,
        valueRhs:
          obj.seqNum === 1
            ? testResult
            : obj.seqNum === 2
            ? props.condition
            : "",
      };
    });
    let newActions = firstRule.ruleActions.map((obj) => {
      return {
        ...obj,
        actionId: null,
        valueRhs: obj.seqNum === 999 ? "Select" : "",
      };
    });

    let newRule = {
      ...firstRule,
      ruleConditions: newConditions,
      ruleActions: newActions,
    };
    const updatedRules = [...rules].concat(newRule);

    setRules(updatedRules);
  };

  const addTestResults = () => {
    let firstRule = { ...rules[0] };
    delete firstRule.ruleId;

    let newConditions = firstRule.ruleConditions.map((obj) => {
      return {
        ...obj,
        conditionId: null,
        valueRhs:
          obj.seqNum === 1 ? "Select" : obj.seqNum === 2 ? props.condition : "",
      };
    });
    let newActions = firstRule.ruleActions.map((obj) => {
      return {
        ...obj,
        actionId: null,
        valueRhs: obj.seqNum === 999 ? "Select" : "",
      };
    });

    let newRule = {
      ...firstRule,
      ruleConditions: newConditions,
      ruleActions: newActions,
    };
    const updatedRules = [...rules].concat(newRule);

    setRules(updatedRules);
  };

  const updateTestResult = (testResult, event) => {
    let copyRules = [...rules];
    for (let i = 0; i < copyRules.length; i++) {
      let X = copyRules[i];
      for (let j = 0; j < X.ruleConditions.length; j++) {
        let Y = X.ruleConditions[j];
        if (j + 1 === 1 && Y["valueRhs"] === testResult) {
          Y["valueRhs"] = event.target.value;
        }
      }
    }
    setRules(copyRules);
  };

  const updateInputDecision = (
    ruleCondition,
    testResult,
    index,
    iny,
    event
  ) => {
    let copyRules = [];
    let count = 0;
    Object.keys(groupData).map((key, inde) => {
      if (inde < index) count = count + groupData[key].length;
      copyRules = copyRules.concat(groupData[key]);
    });
    count = count + iny;

    for (let i = 0; i < copyRules.length; i++) {
      if (i === count) {
        let X = copyRules[i];
        for (let j = 0; j < X.ruleConditions.length; j++) {
          let Y = X.ruleConditions[j];
          if (ruleCondition.seqNum === Y.seqNum) {
            Y["valueRhs"] = event.target.value;
          }
        }
      }
    }
    setRules(copyRules);
  };

  const updateInputDecisionOutput = (
    ruleAction,
    testResult,
    index,
    iny,
    event
  ) => {
    let copyRules = [];
    let count = 0;
    Object.keys(groupData).map((key, inde) => {
      if (inde < index) count = count + groupData[key].length;
      copyRules = copyRules.concat(groupData[key]);
    });
    count = count + iny;

    for (let i = 0; i < copyRules.length; i++) {
      if (i === count) {
        let X = copyRules[i];
        let Y = X.ruleActions[0];
        Y["valueRhs"] = event.target.value;
      }
    }
    setRules(copyRules);
  };

  const setInputDecisionToIgnore = (ruleCondition, index, iny, event) => {
    let copyRules = [];
    let count = 0;
    Object.keys(groupData).map((key, inde) => {
      if (inde < index) count = count + groupData[key].length;
      copyRules = copyRules.concat(groupData[key]);
    });
    count = count + iny;

    for (let i = 0; i < copyRules.length; i++) {
      if (i === count) {
        let X = copyRules[i];
        for (let j = 0; j < X.ruleConditions.length; j++) {
          let Y = X.ruleConditions[j];
          if (ruleCondition.seqNum === Y.seqNum) {
            Y["valueRhs"] = null;
          }
        }
      }
    }
    setRules(copyRules);
  };

  const addColumn = () => {
    let copyRules = [...rules];
    const nextConditionSequence = copyRules[0].ruleConditions.length + 1;
    let updatedOrCondition = orCondition + "&&" + nextConditionSequence;
    setOrCondition(updatedOrCondition);
    setOrNameCondition(getColumnNameCondition(updatedOrCondition));
    const newCondition = {
      sourceObject: "",
      sourceField: "object",
      valueRhs: "",
      seqNum: nextConditionSequence,
      logicalOperator: "&&",
      isDel: false,
      operator: "Equal to",
    };

    copyRules.map((item, i) =>
      copyRules[i].ruleConditions.push({ ...newCondition })
    );
    setRules(copyRules);
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextonText"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const CustomToggleNull = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextNull"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const CustomToggleText = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextonText"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const setColumn = (sourceObject, ruleCondition, sourceField) => {
    let copyRules = [...rules];
    for (let i = 0; i < copyRules.length; i++) {
      let X = copyRules[i];
      for (let j = 0; j < X.ruleConditions.length; j++) {
        let Y = X.ruleConditions[j];
        if (ruleCondition.seqNum === j + 1) {
          Y["sourceField"] = sourceField;
          Y["sourceObject"] = sourceObject;
        }
      }
    }
    setOrNameCondition(getColumnNameCondition(orCondition));
    setRules(copyRules);
  };

  const setOperator = (ruleCondition, event) => {
    let copyRules = [...rules];
    for (let i = 0; i < copyRules.length; i++) {
      let X = copyRules[i];
      for (let j = 0; j < X.ruleConditions.length; j++) {
        let Y = X.ruleConditions[j];
        if (ruleCondition.seqNum === j + 1) {
          Y["operator"] = event.target.value;
        }
      }
    }
    setRules(copyRules);
  };

  const getColumnNameOperatorAndValue = (item, seqNum) => {
    for (let i = 0; i < item.ruleConditions.length; i++) {
      if (seqNum === item.ruleConditions[i].seqNum) {
        let ab = getColumnsMetaData();
        let cd = ab[item.ruleConditions[i].sourceField];
        return item.ruleConditions[i].valueRhs === null
          ? ""
          : " <" +
              cd +
              "> is " +
              item.ruleConditions[i].operator +
              " " +
              (seqNum === 2
                ? props.condition
                : item.ruleConditions[i].valueRhs) +
              " ";
      }
    }
  };

  const constructIndividualRulePerRow = (orCondition, rule) => {
    let individualRulePerRow = "";
    individualRulePerRow =
      individualRulePerRow +
      orCondition.replace(/\d+/g, (digit) => {
        const index = parseInt(digit, 10);
        return rule.ruleConditions[index - 1]?.valueRhs === null ? "" : index;
      });

    individualRulePerRow = individualRulePerRow.replace(/(&&)+/g, "&&");
    individualRulePerRow = individualRulePerRow.replace(/(\|\|)+/g, "||");
    individualRulePerRow = individualRulePerRow.replace(/\(\|\|/g, "(");
    individualRulePerRow = individualRulePerRow.replace(/\|\|\)/g, ")");
    individualRulePerRow = individualRulePerRow.replace(/&&\(\)/g, "");
    individualRulePerRow = individualRulePerRow.replace(/&&$/g, "");
    individualRulePerRow = individualRulePerRow.replace(/\((\d+)\)/g, "$1");
    individualRulePerRow = removeDuplicates(individualRulePerRow);
    individualRulePerRow = removeColumnsifInGrouping(individualRulePerRow);
    return individualRulePerRow;
  };

  const constructVerbalRule = (orCondition, rule) => {
    let verbalRule = "IF \n\t";
    let individualOrCondition = constructIndividualRulePerRow(
      orCondition,
      rule
    );
    verbalRule =
      verbalRule +
      individualOrCondition.replace(/\d+/g, (digit) => {
        const index = parseInt(digit, 10);
        return getColumnNameOperatorAndValue(rule, index);
      });
    verbalRule = verbalRule.replace(/&&+/g, "And");
    verbalRule = verbalRule.replace(/\|\|+/g, "Or");
    verbalRule = verbalRule.replace(/(And)+/g, "And");
    verbalRule = verbalRule.replace(/(Or)+/g, "Or");
    verbalRule = verbalRule.replace(/\(Or/g, "(");
    verbalRule = verbalRule.replace(/Or\)/g, ")");
    verbalRule = verbalRule.replace(/And\(\)/g, "");
    verbalRule = verbalRule.replace(/And$/g, "");
    verbalRule = verbalRule.replace(/And/g, "\nAnd\n\t");
    if (rule.ruleActions[0].valueRhs === "")
      verbalRule = verbalRule + "\nTHEN \n\t" + " Select" + " ";
    else
      verbalRule =
        verbalRule + "\nTHEN \n\t" + rule.ruleActions[0].valueRhs + " ";

    return verbalRule;
  };

  const groupData = rules.reduce((ruleArray, rule) => {
    const key = rule.ruleConditions.find(
      (obj) => obj.sourceField === "Result"
    ).valueRhs;
    ruleArray[key] = ruleArray[key] || [];
    ruleArray[key].push(rule);
    return ruleArray;
  }, {});

  const removeRow = (testResult, index, iny, event) => {
    let copyRules = [];
    let count = 0;
    Object.keys(groupData).map((key, inde) => {
      if (inde < index) count = count + groupData[key].length;
      copyRules = copyRules.concat(groupData[key]);
    });
    count = count + iny;

    if (copyRules.length === 1) copyRules = [...initialRules];
    else
      for (let i = 0; i < copyRules.length; i++) {
        if (i === count) {
          copyRules.splice(i, 1);
        }
      }
    setRules(copyRules);
  };

  const handleRuleConditionVisualizationModal = (
    testResult,
    index,
    iny,
    event
  ) => {
    let copyRules = [];
    let count = 0;
    let rule = "";
    Object.keys(groupData).map((key, inde) => {
      if (inde < index) count = count + groupData[key].length;
      copyRules = copyRules.concat(groupData[key]);
    });

    count = count + iny;
    for (let i = 0; i < copyRules.length; i++) {
      if (i === count) {
        rule = constructVerbalRule(orCondition, copyRules[i]);
      }
    }
    setRules(copyRules);
    setRuleConditionVisualizationModal(true);
    setRuleConditionForRow(rule);
  };

  function removeDuplicates(inputString) {
    const parts = inputString.split("&&");
    const uniqueElements = {};
    const uniqueParts = [];
    for (const part of parts) {
      if (!uniqueElements[part]) {
        uniqueElements[part] = true;
        uniqueParts.push(part);
      }
    }
    const result = uniqueParts.join("&&");
    return result;
  }

  function findHighestNumber(str) {
    const numbers = str.match(/\d+(\.\d+)?/g); // Extract all numbers from the string
    if (!numbers) return null; // Return null if no numbers are found
    const parsedNumbers = numbers.map(Number); // Convert the extracted strings to numbers
    const highestNumber = Math.max(...parsedNumbers); // Find the highest number
    return highestNumber;
  }

  function removeColumnsifInGrouping(copyOrConditions) {
    let columnLength = findHighestNumber(copyOrConditions);
    let columnsSeqNum = Array.from({ length: columnLength }, (_, i) =>
      (i + 1).toString()
    ).map(Number);
    let newString = "";
    const matches = copyOrConditions.match(/\((.*?)\)/g);

    const outputArray = [];
    if (matches === null) return copyOrConditions;

    if (matches !== null && matches?.length > 0) {
      for (const match of matches) {
        newString = newString + match;
        if (match !== matches[matches.length - 1]) newString = newString + "&&";
        const numbers = match
          .replace(/[()]/g, "") // Remove parentheses
          .split("||") // Split by 'or'
          .map(Number); // Convert strings to numbers
        outputArray.push(...numbers); // Add numbers to the output array
      }
    }
    const subtractedArray = columnsSeqNum.filter(
      (item) => !outputArray.includes(item)
    );
    for (let i = subtractedArray.length - 1; i >= 0; i--) {
      let andOperator = "&&";
      newString = subtractedArray[i] + andOperator + newString;
    }
    return newString;
  }

  const removeColumn = (event) => {
    let copyOrCondition = orCondition;
    const seqnumsToRemove = selectedColumns
      .map((str) => parseInt(str.split('-')[1]))
      .sort();

    let copyRules = [...rules];
    copyRules.map((item, i) => {
      for (let i = 0; i < seqnumsToRemove.length; i++) {
        const seqnumToRemove = seqnumsToRemove[i] - i;
        const indexToRemove = item.ruleConditions.findIndex(
          (obj) => obj.seqNum === seqnumToRemove
        );

        if (indexToRemove !== -1) {
          item.ruleConditions.splice(indexToRemove, 1);
          for (let j = indexToRemove; j < item.ruleConditions.length; j++) {
            item.ruleConditions[j].seqNum--;
          }
        }
      }
    });

    for (let i = 0; i < seqnumsToRemove.length; i++) {
      const seqnumToRemove = seqnumsToRemove[i] - i;
      copyOrCondition = copyOrCondition.split(seqnumToRemove).join("");
      copyOrCondition = copyOrCondition.replace(/\d+/g, function (match) {
        if (parseInt(match) > seqnumToRemove) {
          return match - 1;
        } else {
          return match;
        }
      });
    }
    copyOrCondition = copyOrCondition.replace(/(&&)+/g, "&&");
    copyOrCondition = copyOrCondition.replace(/(\|\|)+/g, "||");
    copyOrCondition = copyOrCondition.replace(/\(\|\|/g, "(");
    copyOrCondition = copyOrCondition.replace(/\|\|\)/g, ")");
    copyOrCondition = copyOrCondition.replace(/&&$/g, "");
    copyOrCondition = copyOrCondition.replace(
      /\((\d+)\)/g,
      function (match, digit) {
        return digit;
      }
    );
    copyOrCondition = removeDuplicates(copyOrCondition);
    copyOrCondition = removeColumnsifInGrouping(copyOrCondition);
    setOrCondition(copyOrCondition);
    setOrNameCondition(getColumnNameCondition(copyOrCondition));

    setRules(copyRules);
    setSelectedColumns([]);
  };

  const getColumnName = (seqNum) => {
    let name = rules.map((item, i) => {
      for (let i = 0; i < item.ruleConditions.length; i++) {
        if (seqNum === item.ruleConditions[i].seqNum) {
          let ab = getColumnsMetaData();
          let cd = ab[item.ruleConditions[i].sourceField];
          return cd;
        }
      }
    });
    return name[0] === undefined ? "<Object>" : " <" + name[0] + "> ";
  };

  function getColumnNameCondition(str) {
    let inputString = str.replace(/\d+/g, (digit) => {
      const index = parseInt(digit, 10);
      return getColumnName(index);
    });
    inputString = inputString.replace(/&&+/g, "And");
    inputString = inputString.replace(/\|\|+/g, "Or");
    inputString = inputString.replace(/\)And/g, ") <And");
    inputString = inputString.replace(/And\(/g, "And> (");
    inputString = inputString.replace(/\)And\(/g, ") <And> (");
    return inputString;
  }

  const groupColumn = (event) => {
    if (selectedColumns.length < 2) return;

    const seqnumsToGroup = selectedColumns
    .map((str) => parseInt(str.split('-')[1]))
    .sort((a, b) => a - b);

    const columnsSeqNum = [];
    columnsSeqNum.push(1);
    columnsSeqNum.push(2);

    columnsSeqNum.push(
      ...copyColumns.map((str) => parseInt(str.split('-')[1])).sort()
    );
    let copyOrConditions = orCondition;

    const newOrCondition = `&&(${seqnumsToGroup.join("||")})`;
    if (copyOrConditions.includes(newOrCondition)) return; // If condition already Exists, return
    copyOrConditions = copyOrConditions + newOrCondition;
    let newString = "";
    const regex = /\((.*?)\)/g;
    const matches = copyOrConditions.match(regex);
    const outputArray = [];
    for (const match of matches) {
      newString = newString + match;
      if (match !== matches[matches.length - 1]) newString = newString + "&&";
      const numbers = match
        .replace(/[()]/g, "") // Remove parentheses
        .split("||") // Split by 'or'
        .map(Number); // Convert strings to numbers
      outputArray.push(...numbers); // Add numbers to the output array
    }
    const subtractedArray = columnsSeqNum.filter(
      (item) => !outputArray.includes(item)
    );
    for (let i = subtractedArray.length - 1; i >= 0; i--) {
      let andOperator = "&&";
      newString = subtractedArray[i] + andOperator + newString;
    }
    setOrCondition(newString);

    let g = getColumnNameCondition(newString);
    setOrNameCondition(g);

    let copyRules = [...rules];
    copyRules.map((item, i) => {
      for (let i = 0; i < item.ruleConditions.length; i++) {
        if (outputArray.includes(item.ruleConditions[i].seqNum))
          item.ruleConditions[i].logicalOperator = "||";
        else item.ruleConditions[i].logicalOperator = "&&";
      }
    });
    setSelectedColumns([]);
    setRules(copyRules);
  };

  const handleColumnCheck = (event) => {
    const newCheckBox = [...selectedColumns];
    const index = newCheckBox.indexOf(event.target.id);
    if (index === -1) newCheckBox.push(event.target.id);
    else newCheckBox.splice(index, 1);
    setSelectedColumns(newCheckBox);
  };

  const getDropdownCodeSets = async (tableName) => {
    let response = await fetchCodeSetTable(tableName);
    if (response.ok) {
      let data = await response.json();
      if (tableName === "Administrative Sex") {
        setAdministrativeSexCodeSets(data.refTableValues);
      } else if (tableName === "Race") {
        setRaceCodeSets(data.refTableValues);
      } else if (tableName === "Ethnic Group") {
        setEthnicGroupCodeSet(data.refTableValues);
      } else if (tableName === "Patient Death Indicator") {
        setPatientDeathIndicatorCodeSets(data.refTableValues);
      } else if (tableName === "Existing Case") {
        setExistingCaseCodeSets(data.refTableValues);
      } else if (tableName === "Specimen Source") {
        setSpecimenType(data.refTableValues);
      } else if (tableName === "Case Test Result") {
        setCaseTestResult(data.refTableValues);
      // } else if (tableName === "Specimen Source Site") {
      //   setSpecimenSourceSite(data.refTableValues);
      } else if (tableName === "Existing Case Number") {
        setExistingCaseNumbers(data.refTableValues);
      } else if (tableName === "Syphilis Test Combination Status") {
        setSyphilisTestCombinationTable(data.refTableValues);
      } else if (tableName === "Multiple Tier One Positive Tests") {
        setMultipleTierOnePositiveTests(data.refTableValues);
      } else if (tableName === "Existing Single Syphilis Test Flag") {
        setExistingSingleSyphilisTestFlag(data.refTableValues);
      } else if (tableName === "Has Closed Investigation Status") {
        setHasClosedInvestigationStatus(data.refTableValues);
      } else if (tableName === "Case Status") {
        setCaseStatus(data.refTableValues);
      } else if (tableName === "Case Type") {
        setCaseType(data.refTableValues);
      } else if (tableName === "Lock Status") {
        setLockStatus(data.refTableValues);
      } else if (tableName === HAS_EXPIRED_INVESTIGATION_CASE_STATUS) {
        setHasExpiredInvestigationCaseStatus(data.refTableValues);
      }
    }
  };

  const getDropdownCodeSetsValues = (sourceField) => {
    let dropdownValues = [];
    if (sourceField === "PID8") {
      dropdownValues = administrativeSexCodeSets;
    } else if (sourceField === "PID10.1") {
      dropdownValues = raceCodeSets;
    } else if (sourceField === "PID22.1") {
      dropdownValues = ethnicGroupCodeSet;
    } else if (sourceField === "PID30") {
      let newObject = patientDeathIndicatorCodeSets.map((item) => {
        return {
          referenceTableValueId: item.referenceTableValueId,
          reference_code: item.reference_code,
          reference_Code_description: `${item.reference_Code_description} - ${item.reference_code} - ${item.reference_Code_system}`,
        };
      });
      dropdownValues = newObject;
    } else if (sourceField === "existingCase") {
      dropdownValues = existingCaseCodeSets;
    } else if (sourceField === "SPM8.1") {
      dropdownValues = specimenSourceSite;
    } else if (sourceField === "SPM4") {
      dropdownValues = specimenType;
    } else if (sourceField === "caseTestResult") {
      dropdownValues = caseTestResult;
    } else if (sourceField === "existingCaseNumber") {
      dropdownValues = existingCaseNumber;
    } else if (sourceField === "testCombinationResult") {
      dropdownValues = syphilisTestCombinationTable;
    } else if (sourceField === "multipleTierOnePositiveTests") {
      dropdownValues = multipleTierOnePositiveTests;
    } else if (sourceField === "existingSingleSyphilisTestFlag") {
      dropdownValues = existingSingleSyphilisTestFlag;
    } else if (sourceField === "hasClosedInvestigationStatus") {
      dropdownValues = hasClosedInvestigationStatus;
    } else if (sourceField === "caseStatus") {
      dropdownValues = caseStatus;
    } else if (sourceField === "caseType") {
      dropdownValues = caseType;
    } else if (sourceField === "lockStatus") {
      dropdownValues = lockStatus;
    } else if (sourceField === "hasExpiredInvestigationCaseStatus") {
      dropdownValues = hasExpiredInvestigationCaseStatus;
    }
    return dropdownValues.length > 0
      ? _.sortBy(dropdownValues, (item) => item.reference_Code_description)
      : [];
  };

  const changeInputType = (
    ruleCondition,
    testResult,
    index,
    iny,
    isRequired
  ) => {
    if (HL7_FIELDS_FOR_DATE_VALUES.includes(ruleCondition.sourceField)) {
      return (
        <Form.Control
          style={{ minWidth: "213px", maxWidth: "213px" }}
          className="decisionTableCellInput"
          required={isRequired}
          type="date"
          placeholder="Enter Date"
          name={ruleCondition.sourceField}
          value={ruleCondition.valueRhs}
          onChange={(event) =>
            updateInputDecision(ruleCondition, testResult, index, iny, event)
          }
        />
      );
    } else if (
      HL7_FIELDS_FOR_NUMERIC_VALUES.includes(ruleCondition.sourceField)
    ) {
      return (
        <Form.Control
          style={{ maxWidth: "213px" }}
          className="decisionTableCellInput"
          required={isRequired}
          type="number"
          placeholder="Enter Value"
          name={ruleCondition.sourceField}
          value={ruleCondition.valueRhs}
          onChange={(event) =>
            updateInputDecision(ruleCondition, testResult, index, iny, event)
          }
        />
      );
    } else if (
      HL7_FIELDS_FOR_DROPDOWN_VALUES.includes(ruleCondition.sourceField)
    ) {
      return (
        <Form.Select
          style={{ minWidth: "213px", maxWidth: "213px" }}
          className="decisionTableCellInput"
          aria-label="Choose Item"
          value={ruleCondition.valueRhs}
          required={isRequired}
          onChange={(event) =>
            updateInputDecision(ruleCondition, testResult, index, iny, event)
          }
        >
          <option hidden value="">
            Choose Item
          </option>
          {getDropdownCodeSetsValues(ruleCondition.sourceField).map((val) => {
            return (
              <option
                key={val.referenceTableValueId}
                value={val.reference_code}
              >
                {val.reference_Code_description}
              </option>
            );
          })}
        </Form.Select>
      );
    } else {
      return (
        <Form.Control
          style={{ maxWidth: "213px" }}
          className="decisionTableCellInput"
          required={isRequired}
          placeholder="Enter Value"
          name={ruleCondition.sourceField}
          value={ruleCondition.valueRhs}
          onChange={(event) =>
            updateInputDecision(ruleCondition, testResult, index, iny, event)
          }
        />
      );
    }
  };

  useImperativeHandle(ref, () => ({
    getRules() {
      let copyRules = [...rules];
      props.setRulesList(rules);
      setRules(initialRules);
      return copyRules;
    },
    setNewRules() {
      props.setRulesList([]);
      setRules(JSON.parse(JSON.stringify(initialRules)));
    },
  }));

  useEffect(() => {
    if (props.rulesList.length > 0) setRules(props.rulesList);
  }, [props.rulesList]);

  useEffect(() => {
    let newOptions = [...OUTPUT_OPTIONS];

    // Define the items to add/remove
    const itemsToAdd = ["Create Acute Case", "Create Chronic Case", "Create Perinatal Case"];

    if (props.condition && (props.condition.includes("Hepatitis B") || props.condition.includes("Hepatitis C"))) {
      itemsToAdd.forEach(item => {
        if (!newOptions.includes(item)) {
          newOptions.push(item);
        }
      });
      newOptions = newOptions.filter(option => option !== "Create New Investigation");

    } else if (props.condition && (props.condition.includes("Q Fever Acute"))) {
      itemsToAdd.filter(option => option !== "Create Perinatal Case")
                .forEach(item => {
                  if (!newOptions.includes(item)) {
                    newOptions.push(item);
                  }
                })
      newOptions = newOptions.filter(option => option !== "Create New Investigation");
    } else {
      newOptions = newOptions.filter(option => !itemsToAdd.includes(option));

      if (!newOptions.includes("Create New Investigation")) {
        newOptions.push("Create New Investigation");
      }
    }

    setOutputOptions(newOptions);

  }, [props.condition]);

  useEffect(() => {
    getDropdownCodeSets("Administrative Sex");
    getDropdownCodeSets("Race");
    getDropdownCodeSets("Ethnic Group");
    getDropdownCodeSets("Patient Death Indicator");
    getDropdownCodeSets("Existing Case");
    // getDropdownCodeSets("Specimen Source Site");
    getDropdownCodeSets("Specimen Source");
    // getDropdownCodeSets("Case Test Result");
    // getDropdownCodeSets("Existing Case Number");   May be used later as per Jack
    getDropdownCodeSets("Syphilis Test Combination Status");
    getDropdownCodeSets("Multiple Tier One Positive Tests");    
    getDropdownCodeSets("Existing Single Syphilis Test Flag");
    getDropdownCodeSets("Has Closed Investigation Status");
    getDropdownCodeSets("Case Status");
    getDropdownCodeSets("Case Type");
    getDropdownCodeSets("Lock Status");
    // getDropdownCodeSets(HAS_EXPIRED_INVESTIGATION_CASE_STATUS);
  }, []);

  useEffect(() => {
    if (orCondition && orCondition.trim() === "") {
      if (props.rulesList.length > 0) {
        let str = "";
        for (
          var i = 1;
          i <= props.rulesList[0].ruleConditions.length - 1;
          i++
        ) {
          str = str + i + "&&";
        }
        str = str + props.rulesList[0].ruleConditions.length;
        setOrCondition(str);
        setOrNameCondition(getColumnNameCondition(str));
      } else {
        setOrCondition("1&&2");
        setOrNameCondition(getColumnNameCondition("1&&2"));
      }
    }
  }, [rules, props.rulesList, orCondition]);

  return (
    <>
      <div className="tableContainer">
        <Table className="tableN" bordered hover size="sm">
          <thead>
            <tr>
              <th style={{ minWidth: "250px" }}>
                <Dropdown
                  as={ButtonGroup}
                  autoClose="outside"
                  style={{
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row>
                      <Col sm={1}>1</Col>
                      <Col>Test Result IS</Col>
                    </Row>
                  </div>
                  <Dropdown.Toggle
                    as={CustomToggle}
                    split
                    onClick={() => setShowConditionModal(true)}
                  />
                </Dropdown>
              </th>
              <th style={{ minWidth: "250px" }}>
                <Row>
                  <Col sm={1}>2</Col>
                  <Col>Condition</Col>
                </Row>
              </th>
              {rules[0] &&
                rules[0].ruleConditions
                  .sort((a, b) => a.seqNum - b.seqNum)
                  .filter(
                    (ruleCondition) =>
                      ruleCondition.seqNum !== 1 && ruleCondition.seqNum !== 2
                  )
                  .map((ruleCondition) => (
                    <th
                      style={{
                        minWidth: "250px",
                        backgroundColor:
                          ruleCondition.logicalOperator === "||" && "#FFF8E7",
                      }}
                    >
                      <Row>
                        <Col sm={1}>{ruleCondition?.seqNum}</Col>
                        <Col>
                          <Form.Select
                            name="object"
                            className="decisionTableCellInput"
                            style={{ fontWeight: "bold" }}
                            aria-label="Object"
                            value={ruleCondition.sourceField}
                            onChange={(event) => {
                              setColumn(
                                event.target.options[event.target.selectedIndex]
                                  .parentNode.label,
                                ruleCondition,
                                event.target.value
                              );
                            }}
                            required
                          >
                            <option value="" hidden>
                              Object
                            </option>
                            <optgroup
                              label="Message"
                              style={{
                                fontWeight: "lighter",
                                backgroundColor: "white",
                              }}
                            >
                              {props
                                .getFieldOptions("Message")
                                .map((fieldItem) => {
                                  return (
                                    <option
                                      style={{ backgroundColor: "white" }}
                                      key={fieldItem.referenceTableValueId}
                                      value={fieldItem.reference_code}
                                    >
                                      {fieldItem.reference_Code_description}
                                    </option>
                                  );
                                })}
                            </optgroup>
                            <optgroup
                              label="Surveillance System"
                              style={{
                                fontWeight: "lighter",
                                backgroundColor: "white",
                              }}
                            >
                              {props
                                .getFieldOptions("Surveillance System")
                                .map((fieldItem) => {
                                  return (
                                    <option
                                      style={{ backgroundColor: "white" }}
                                      key={fieldItem.referenceTableValueId}
                                      value={fieldItem.reference_code}
                                    >
                                      {fieldItem.reference_Code_description}
                                    </option>
                                  );
                                })}
                            </optgroup>
                            <optgroup
                              label="Configurations"
                              style={{
                                fontWeight: "lighter",
                                backgroundColor: "white",
                              }}
                            >
                              {props
                                .getFieldOptions("Configurations")
                                .map((fieldItem) => {
                                  return (
                                    <option
                                      style={{ backgroundColor: "white" }}
                                      key={fieldItem.referenceTableValueId}
                                      value={fieldItem.reference_code}
                                    >
                                      {fieldItem.reference_Code_description}
                                    </option>
                                  );
                                })}
                            </optgroup>
                          </Form.Select>
                        </Col>
                      </Row>
                    </th>
                  ))}
              <th style={{ minWidth: "50px" }}>
                <Button
                  className="tableAddColumnBtn flexCenter generalFont"
                  onClick={() => addColumn()}
                >
                  <img
                    style={{ marginRight: "10px" }}
                    src={`${validateAndSanitizeUrl(S3_URL)}add-column-icon.png`}
                    className="ruleModalAddIcon"
                    alt=""
                  ></img>
                </Button>
              </th>
              <th style={{ minWidth: "250px" }}>Output</th>
              <th style={{ width: "50px" }}></th>
              <th style={{ width: "50px" }}></th>
            </tr>
            <tr>
              <th className="decisionTableTh min-width-150"></th>
              <th className="decisionTableTh ">Equals to</th>
              {rules[0].ruleConditions
                .filter(
                  (ruleCondition) =>
                    ruleCondition.seqNum !== 1 && ruleCondition.seqNum !== 2
                )
                .map((ruleCondition) => (
                  <th
                    width="10%"
                    className="decisionTableTh min-width-150"
                    style={{
                      backgroundColor:
                        ruleCondition.logicalOperator === "||" && "#FFF8E7",
                    }}
                  >
                    {ruleCondition.sourceField !== "object" && (
                      <Form.Select
                        name="operator"
                        className="decisionTableCellInput"
                        aria-label="Operator"
                        value={ruleCondition.operator}
                        onChange={(event) => setOperator(ruleCondition, event)}
                        required
                      >
                        <option value="">Operator</option>
                        {props
                          .getOperatorsOptions(
                            ruleCondition.sourceObject,
                            ruleCondition.sourceField
                          )
                          .map(([key, val]) => {
                            return (
                              <option key={key} value={val}>
                                {val}
                              </option>
                            );
                          })}
                      </Form.Select>
                    )}
                  </th>
                ))}
              <th className="decisionTableTh"></th>
              <th className="decisionTableTh min-width-150"></th>
              <th className="decisionTableTh" style={{ width: "50px" }}></th>
              <th className="decisionTableTh" style={{ width: "50px" }}></th>
            </tr>
          </thead>
          <tbody>
            {groupData &&
              Object.keys(groupData).map((testResult, index) => {
                return (
                  <>
                    {groupData[testResult].map((rule, iny) => {
                      return (
                        <tr>
                          {iny === 0 && (
                            <td rowSpan={groupData[testResult].length + 1}>
                              <Form.Select
                                name="sourceObject"
                                className="decisionTableCellInput"
                                aria-label="Object"
                                required
                                value={
                                  rule.ruleConditions.find(
                                    (obj) => obj.sourceField === "Result"
                                  ).valueRhs
                                }
                                onChange={(event) =>
                                  updateTestResult(testResult, event)
                                }
                              >
                                <option hidden value="">
                                  Select
                                </option>
                                {TEST_RESULT_OPTIONS.sort((a, b) =>
                                  a > b ? 1 : -1
                                ).map((entry) => {
                                  return (
                                    <option key={entry} value={entry}>
                                      {entry}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            </td>
                          )}

                          {rule.ruleConditions.find(
                            (obj) => obj.sourceField === "condition"
                          ) && (
                            <td
                              style={{
                                backgroundColor: "#d1d1d1",
                              }}
                            >
                              {props.condition
                                ? props.condition
                                : rule.ruleConditions.find(
                                    (obj) => obj.sourceField === "condition"
                                  ).valueRhs}
                            </td>
                          )}

                          {rule.ruleConditions
                            .sort((a, b) => a.seqNum - b.seqNum)
                            .map((ruleCondition, inx) => {
                              if (ruleCondition.seqNum > 2)
                                return (
                                  <>
                                    <td
                                      style={{
                                        backgroundColor:
                                          ruleCondition.valueRhs === null
                                            ? "#d1d1d1"
                                            : "white",
                                      }}
                                    >
                                      {" "}
                                      <Dropdown
                                        as={ButtonGroup}
                                        autoClose="outside"
                                      >
                                        {ruleCondition.valueRhs === null ? (
                                          <>
                                            <Form.Text className="decisionTableCellInput">
                                              Null
                                            </Form.Text>
                                            <Dropdown.Toggle
                                              as={CustomToggleNull}
                                              split
                                            />
                                          </>
                                        ) : (
                                          <>
                                            {changeInputType(
                                              ruleCondition,
                                              testResult,
                                              index,
                                              iny,
                                              true
                                            )}
                                            <Dropdown.Toggle
                                              as={CustomToggleText}
                                              split
                                            />
                                          </>
                                        )}

                                        <Dropdown.Menu className="noTransformFullScreen">
                                          <Dropdown.Item>
                                            {changeInputType(
                                              ruleCondition,
                                              testResult,
                                              index,
                                              iny,
                                              false
                                            )}
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            name={ruleCondition.sourceField}
                                            onClick={(event) =>
                                              setInputDecisionToIgnore(
                                                ruleCondition,
                                                index,
                                                iny,
                                                event
                                              )
                                            }
                                          >
                                            Ignore
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </td>
                                  </>
                                );
                            })}
                          <td></td>
                          <td>
                            <Form.Select
                              name="column999"
                              className="decisionTableCellInput"
                              aria-label="Object"
                              required
                              value={rule.ruleActions[0].valueRhs}
                              onChange={(event) =>
                                updateInputDecisionOutput(
                                  rule.ruleActions[0],
                                  testResult,
                                  index,
                                  iny,
                                  event
                                )
                              }
                            >
                              <option hidden value="">
                                Select
                              </option>
                              {outputOptions.map((value, index) => (
                                <option key={index} value={value}>
                                  {value}
                                </option>
                              ))}
                            </Form.Select>
                          </td>
                          <td>
                            <Button
                              disabled={orCondition === ""}
                              onClick={(event) =>
                                handleRuleConditionVisualizationModal(
                                  testResult,
                                  index,
                                  iny,
                                  event
                                )
                              }
                              className="removeButtonStyle generalFont flexCenter "
                            >
                              {" "}
                              <img
                                src={`${validateAndSanitizeUrl(S3_URL)}condition-icon.png`}
                                className="buttonIcon"
                                alt=""
                              ></img>
                            </Button>
                          </td>
                          <td>
                            <Button
                              onClick={(event) =>
                                removeRow(testResult, index, iny, event)
                              }
                              className="removeButtonStyle generalFont flexCenter "
                            >
                              {" "}
                              <img
                                src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
                                className="buttonIcon"
                                alt=""
                              ></img>
                            </Button>
                          </td>
                        </tr>
                      );
                    })}

                    <tr>
                      <td colSpan="100%">
                        <Button
                          className="tableAddFieldBtn flexCenter generalFont"
                          onClick={() => addDecisionsFields(testResult)}
                        >
                          <img
                            style={{ marginRight: "10px" }}
                            src={`${validateAndSanitizeUrl(S3_URL)}plus-vector-blue-icon.png`}
                            className="ruleModalAddIcon"
                            alt=""
                          ></img>
                          Add Field
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td className="no-border" colSpan="100%" />
                    </tr>
                  </>
                );
              })}
          </tbody>
        </Table>
        {Object.keys(groupData).includes("Select") ? (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id="tooltip-disabled">
                {" "}
                Select Test Result from the dropdown to Add another Test Result!
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <Button
                className="addNewBtn flexCenter generalFont"
                onClick={addTestResults}
                disabled={Object.keys(groupData).includes("Select")}
              >
                <img
                  style={{ marginRight: "10px" }}
                  src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                  className="ruleModalAddIcon"
                  alt=""
                ></img>
                Add Test Result
              </Button>
            </span>
          </OverlayTrigger>
        ) : (
          <Button
            className="addNewBtn flexCenter generalFont"
            onClick={addTestResults}
            disabled={Object.keys(groupData).includes("Select")}
          >
            <img
              style={{ marginRight: "10px" }}
              src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
              className="ruleModalAddIcon"
              alt=""
            ></img>
            Add Test Result
          </Button>
        )}
        <br /> <br />
      </div>
      <Modal
        show={showConditionModal}
        onHide={handleConditionModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Rule Grouping Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Group className="mb-3" controlId="ruleName">
              <Row>
                <Col>
                  <RulesScreenOrCondition orNameCondition={orNameCondition} />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3" controlId="columns">
              {rules[0].ruleConditions
                .filter(
                  (ruleCondition) =>
                    ruleCondition.seqNum !== 1 && ruleCondition.seqNum !== 2
                )
                .map((ruleCondition) => {
                  copyColumns.push(
                    `column-${ruleCondition.seqNum}-${ruleCondition.sourceField}`
                  );
                  return (
                    <div
                      key={`column-${ruleCondition.seqNum}-${ruleCondition.sourceField}`}
                      className="mb-3"
                    >
                      <Form.Check
                        type="checkbox"
                        id={`column-${ruleCondition.seqNum}-${ruleCondition.sourceField}`}
                        label={`${
                          getColumnsMetaData()[ruleCondition.sourceField]
                        }-${ruleCondition.seqNum}`}
                        checked={selectedColumns.includes(
                          `column-${ruleCondition.seqNum}-${ruleCondition.sourceField}`
                        )}
                        onClick={handleColumnCheck}
                      />
                    </div>
                  );
                })}
            </Form.Group>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            className=" tableAddTestResultBtn flexCenter generalFont"
            onClick={groupColumn}
          >
            Group Columns with Or
          </Button>
          <Button
            className="tableAddFieldBtn flexCenter generalFont"
            onClick={removeColumn}
          >
            Remove Columns
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={ruleConditionVisualizationModal}
        onHide={handleRuleConditionVisualizationModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Applied Rule with Grouping Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Control
              className="modalInput generalFont"
              type="text"
              as="textarea"
              disabled
              value={ruleConditionForRow}
              rows={15}
            />
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            className="tableAddFieldBtn flexCenter generalFont"
            onClick={handleRuleConditionVisualizationModalClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default RulesScreenDecisionTable;
